import { EntityRequestRwdacct } from "../../entity/EntityRequestRwdacct";

export class DtoRequestRwdacctsPutRes extends EntityRequestRwdacct {}
